import {ILaneServiceListItem} from '@/api/swimLaneGroup';

export const genServiceListForRequest = (serviceList: ILaneServiceListItem[]) =>
    serviceList.map(({clusterID, clusterName, clusterRegion, namespace, isHost, serviceName}) => ({
        clusterID, clusterName, clusterRegion, namespace, isHost, serviceName,
    }));
